export { default as PasteOptioin } from './components/PasteOption';
export { default as PasteOptionPlugin } from './plugin/PasteOptionPlugin';
